import React from 'react';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import { useTranslation } from 'react-i18next';
import getOpPlusV3Info from 'store/dashboard/selector/getOpPlusV3Info';
import { useDispatch, useSelector } from 'react-redux';
import addOPPlusSubscriptionAndRedirectToCartOperation from 'store/app/operation/addOPPlusSubscriptionAndRedirectToCartOperation';
import styles from './PlusSavings.module.scss';

interface PlusSavingsProps {
  showRepurchaseButton?: boolean;
}

const PlusSavings = ({ showRepurchaseButton }: PlusSavingsProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const subscriptionData = useSelector(getOpPlusV3Info);

  const onStartShoppingHandler = () => {
    window.location.href = '/';
  };

  const onRepurchasePlusHandler = () => {
    dispatch(addOPPlusSubscriptionAndRedirectToCartOperation());
  };

  return (
    <div className={styles.savings}>
      <div className={styles.savingsDetails}>
        <div className={styles.savingsDetailsItem}>
          <OpIcon icon="parcel-delivered" size="medium" />
          <div>
            <OpText block variant="title-small-bold" className={styles.savingsDetailsItem}>
              {t('txt_plus_total_orders')}:
            </OpText>
            <OpText block variant="headline-small-bold">
              {subscriptionData?.subscriptionStatistics.totalOrders}
            </OpText>
          </div>
        </div>
        <div className={styles.savingsDetailsItem}>
          <OpIcon icon="discount-badge" size="medium" />
          <div>
            <OpText block variant="title-small-bold" className={styles.savingsDetailsItem}>
              {t('txt_plus_total_savings')}:
            </OpText>
            <OpText block variant="headline-small-bold" className={styles.green}>
              <div dangerouslySetInnerHTML={{ __html: subscriptionData?.subscriptionStatistics.savedAmount || '' }} />
            </OpText>
          </div>
        </div>
      </div>
      <div className={styles.separator} />
      <div className={styles.savingsActions}>
        {!showRepurchaseButton && (
          <>
            <OpText variant="title-small-bold">{t('txt_plus_continue')}</OpText>
            <OpButton size="medium" variant="secondary" icon-right="arrow-right" onClick={onStartShoppingHandler}>
              <OpText variant="body-medium-regular">{t('txt_plus_start_shopping')}</OpText>
            </OpButton>
          </>
        )}
        {showRepurchaseButton && (
          <>
            <OpText variant="title-small-bold">{t('txt_plus_repurchase_to_enjoy')}</OpText>
            <OpButton size="medium" variant="secondary" icon-right="arrow-right" onClick={onRepurchasePlusHandler}>
              <OpText variant="body-medium-regular" className={styles.actionButton}>
                {t('txt_plus_membership_repurchase')}
              </OpText>
            </OpButton>
          </>
        )}
      </div>
    </div>
  );
};

export default PlusSavings;
